import {
  capitalize,
  IconButton,
  Button,
  Tooltip,
  Typography,
  Box
} from "@mui/material";
import { ButtonWithIcon } from "../../ui";
import { Add } from "@mui/icons-material";
import Divider from "@mui/material/Divider";
import { Colors } from "../../../styles/theme";
import useDialogModal from "../../../hooks/useDialogModal";
import SearchCustomerDialog from "../dialog/searchCustomer/searchCustomerDialog";
import LinkFamilyMemberDialog from "../dialog/linkFamilyMember";
import LinkOffIcon from '@mui/icons-material/LinkOff';
import ConfirmationDialog from "../../ui/confirmationDialog";
import validLookup from "../../../utils/validLookup";
import { CustomerService } from "../../../service/customerService";
import { toast } from "react-toastify";
import { useEffect, useState } from "react";

export default function FamilyMembers({
  linkTo,
  familyMembers,
  familyMemberClicked
}) {

  const [familyMembersList, setFamilyMembersList] = useState([]);

  const [SearchForCustomerDialog, showSearchCustomerDialog] =
    useDialogModal(SearchCustomerDialog);
  const [
    ConfirmationDialogComp,
    showConfirmationDialog,
    closeConfirmationDialog,
  ] = useDialogModal(ConfirmationDialog);

  const [LinkFamilyMember, showLinkFamilyMemberDialog] =
    useDialogModal(LinkFamilyMemberDialog);

    useEffect(() => {
      setFamilyMembersList(familyMembers);
    },[familyMembers]);

  const linkFamilyMember = () => {
    showLinkFamilyMemberDialog();
    //showAddCustomerDialog();
  };

  const handleLinkFamilyMemberDone = (result) => {
    setFamilyMembersList( fm => [...fm, result] );
  }

  const handleSearchDone = (newMember) => {
    console.log(newMember.id, newMember.familyId);
    //setFamilyMembers( fm => [...fm, newMember]);
  }

  const handleFamilyMemberClick = (familyMember) => {
    familyMemberClicked(familyMember);
  }

  const handleUnlinkFamilyMember = (fm) => {
    showConfirmationDialog(async (action) => {
      if (action === validLookup.confirmationDialogAction.ok) {
        const unlinkResult = await CustomerService.unlinkFamilyMember(fm.id);
        const { code, data, message } = { ...unlinkResult };

        if (code === 0) {
          setFamilyMembersList( fm => fm.filter(f => f.id !== data.id));
          closeConfirmationDialog();
        } else {
          toast.info(message);
        }
      }
    });

  }

  return (
    <Box
      display="flex"
      flexDirection={"row"}
      alignItems="center"
      gap={1}
      flexWrap="wrap"
    >
      {familyMembersList.map((fm) => (
        <Box key={fm.id} sx={{ position: 'relative', display: 'inline-block', mr: 1 }}>
          <Button
            variant="outlined"
            onClick={() => handleFamilyMemberClick(fm)}
            sx={{
              textTransform: 'none',
              pr: 4,
              border: `1px solid ${Colors.dim_grey}`,
              borderRadius: 2,
              '&:hover': {
                backgroundColor: Colors.dove_gray
              }
            }}
          >
            <Typography sx={{ fontSize: "0.875rem" }}>
              {capitalize(fm.fullName)}
            </Typography>
          </Button>
          <Tooltip title="Remove from family">
            <IconButton 
              size="small"
              sx={{ 
                position: 'absolute',
                top: -8,
                right: -8,
                color: Colors.danger,
                backgroundColor: 'white',
                border: `1px solid ${Colors.danger}`,
                '&:hover': {
                  backgroundColor: Colors.danger,
                  color: 'white'
                }
              }} 
              onClick={() => handleUnlinkFamilyMember(fm)}
            >
              <LinkOffIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Box>
      ))}
      
      <ButtonWithIcon
        icon={<Add />}
        title="Link family member"
        onClickHandler={() => linkFamilyMember()}
        sx={{ml: 2}}
      />
      <SearchForCustomerDialog onDone={handleSearchDone} />
      <LinkFamilyMember linkTo={linkTo} onDone={handleLinkFamilyMemberDone} />
      <ConfirmationDialogComp
        message={"Remove this person from family?"}
        label={{
          positive: "Yes",
          negative: "No",
        }}
      />
    </Box>
  );
}
